export const isStaging = process.env.GATSBY_IS_STAGING;
export const isProd =
  (!isStaging &&
    (process.env.NETLIFY || process.env.GATSBY_NETLIFY) &&
    (process.env.BRANCH === 'main' || process.env.GATSBY_BRANCH === 'main')) ||
  process.env.GATSBY_IS_PROD === 'true';
